import React from "react";
import WhatsAppIcon from "./WhatsAppIcon";
import { buildGeneralWhatsAppUrl } from "@/lib/whatsapp";
import { SHOP } from "@/constants/testIds";

export default function FloatingWhatsAppButton() {
  return (
    <a
      data-testid={SHOP.floatingWhatsappBtn}
      href={buildGeneralWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      className="fixed z-40 bottom-20 right-5 sm:bottom-7 sm:right-7 inline-flex items-center gap-2 pl-3 pr-4 h-12 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1FB855] active:scale-95 text-white shadow-lg shadow-emerald-500/30 transition-all"
    >
      <span className="relative w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white/15 grid place-items-center">
        <WhatsAppIcon size={20} />
        <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#FFD700] border-2 border-white pulse-dot" />
      </span>
      <span className="hidden sm:inline text-sm font-extrabold tracking-wide">Order on WhatsApp</span>
    </a>
  );
}
